<template>
  <div>
    <v-btn v-if="isAdd" fab bottom right large color="accent" fixed @click.stop="dialog = !dialog">
      <v-icon>add</v-icon>
    </v-btn>
    <v-btn icon v-else @click.stop="dialog = !dialog">
      <v-icon> mdi-pencil </v-icon>
    </v-btn>
    <v-dialog
      v-if="dialog"
      v-model="dialog"
      scrollable
      max-width="600"
      transition="dialog-bottom-transition"
      @click:outside="resetForm"
    >
      <v-card>
        <v-card-title class="grey lighten-4 py-4 title black--text">
          <div>{{ isAdd ? 'Add new' : 'Edit' }} Medicine</div>
          <v-spacer></v-spacer>
          <v-card-actions v-if="!isAdd">
            <v-btn icon @click="deleteMedicine"><v-icon color="red">delete</v-icon></v-btn>
          </v-card-actions>
        </v-card-title>
        <v-card-text>
          <v-form v-model="Form.valid" ref="medicineForm">
            <v-container grid-list-xs :class="$vuetify.breakpoint.mdAndUp ? 'pa-5' : ''">
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field
                    label="Generic Name *"
                    v-model="Form.genericName"
                    :rules="[(v) => !!v || 'Generic Name is required']"
                    required
                  />
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    label="Trade Name *"
                    v-model="Form.tradeName"
                    :rules="[(v) => !!v || 'Trade Name is required']"
                    required
                  />
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    label="Dosage *"
                    v-model="Form.dosage"
                    :rules="[(v) => !!v || 'Dosage is required']"
                    placeholder="e.g., 500 mg"
                    suffix="mg"
                    required
                  />
                </v-flex>
                <v-flex xs12>
                  <v-textarea
                    label="Detail (TH)"
                    v-model="Form.detailTh"
                    rows="2"
                    placeholder="e.g., รักษาโรคทางอารมณ์ซึมเศร้า"
                  />
                </v-flex>
                <v-flex xs12>
                  <v-textarea
                    label="Detail (EN)"
                    v-model="Form.detailEn"
                    rows="2"
                    placeholder="e.g., Treatment for depression"
                  />
                </v-flex>
                <v-row justify="space-between" no-gutters>
                  <v-flex xs12 md6>
                    <v-text-field
                      label="Dosage/Day (TH)"
                      v-model="Form.dosageTh"
                      placeholder="e.g., 1-3 เม็ด/วัน"
                      class="mr-4"
                    />
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field label="Dosage/Day (EN)" v-model="Form.dosageEn" placeholder="e.g., 1-3 tablets/day" />
                  </v-flex>
                </v-row>
                <v-row justify="space-between" no-gutters>
                  <v-flex xs12 md6>
                    <v-text-field
                      label="How to Take (TH)"
                      v-model="Form.howToTakeTh"
                      placeholder="e.g., หลังอาหาร"
                      class="mr-4"
                    />
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field label="How to Take (EN)" v-model="Form.howToTakeEn" placeholder="e.g., after meal" />
                  </v-flex>
                </v-row>
                <v-row justify="space-between" no-gutters>
                  <v-flex xs12 md6>
                    <v-text-field
                      label="When to Take (TH)"
                      v-model="Form.timeTh"
                      placeholder="e.g., เช้า-เย็น"
                      class="mr-4"
                    />
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field label="When to Take (EN)" v-model="Form.timeEn" placeholder="e.g., morning-evening" />
                  </v-flex>
                </v-row>
                <v-row justify="space-between" no-gutters>
                  <v-flex xs12 md6>
                    <v-text-field
                      label="Price *"
                      v-model="Form.price"
                      :rules="[(v) => !!v || 'Price is required']"
                      placeholder="e.g., 10.00"
                      suffix="THB"
                      required
                      @keypress="onlyNumberAndDecimal"
                      @input="
                        (value) => {
                          if (!value) return;
                          let sanitized = value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');
                          this.Form.price = sanitized;
                        }
                      "
                      class="mr-4"
                    />
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      label="Cost *"
                      v-model="Form.cost"
                      :rules="[(v) => !!v || 'Cost is required']"
                      placeholder="e.g., 10.00"
                      suffix="THB"
                      required
                      @keypress="onlyNumberAndDecimal"
                      @input="
                        (value) => {
                          if (!value) return;
                          let sanitized = value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');
                          this.Form.cost = sanitized;
                        }
                      "
                    />
                  </v-flex>
                </v-row>
                <v-flex xs12>
                  <v-radio-group v-model="unitSelect" row>
                    <template v-slot:label>
                      <div>Select Unit *</div>
                    </template>
                    <v-radio
                      label="เม็ด"
                      :value="{
                        en: 'Pill',
                        th: 'เม็ด',
                      }"
                    ></v-radio>
                    <v-radio
                      label="แผง"
                      :value="{
                        en: 'Pack',
                        th: 'แผง',
                      }"
                    ></v-radio>
                    <v-flex xs6>
                      <v-text-field
                        label="Total pills/pack"
                        v-model="Form.sellUnit"
                        placeholder="e.g., 10"
                        suffix="pills/pack"
                        class="ml-4"
                        @keypress="onlyNumberAndDecimal"
                      />
                    </v-flex>
                  </v-radio-group>
                </v-flex>
                <v-flex>
                  <v-card-actions>
                    <v-btn
                      color="accent"
                      :disabled="!Form.valid"
                      @click="
                        () => {
                          isAdd ? addNewMedicine() : updateMedicine();
                        }
                      "
                      >{{ isAdd ? 'Create' : 'Update' }}</v-btn
                    >
                  </v-card-actions>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Forms from '../../../../form/form';
import axios from 'axios';

export default {
  data() {
    return {
      dialog: false,
      unitSelect: {
        en: 'Pill',
        th: 'เม็ด',
      },
      medicineId: null,
      Form: new Forms({
        data: () => ({
          genericName: '',
          tradeName: '',
          dosage: '',
          sellUnit: null,
          unitEn: '',
          unitTh: '',
          dosageEn: '',
          dosageTh: '',
          howToTakeEn: '',
          howToTakeTh: '',
          price: null,
          cost: null,
          timeEn: '',
          timeTh: '',
          detailEn: '',
          detailTh: '',
          active: true,
        }),
      }),
    };
  },
  props: {
    isAdd: {
      type: Boolean,
      default: true,
    },
    medicine: {
      type: Object,
    },
  },
  computed: {},
  methods: {
    preparePayload() {
      this.Form.unitEn = this.unitSelect.en;
      this.Form.unitTh = this.unitSelect.th;
      const payload = {
        genericName: this.Form.genericName,
        tradeName: this.Form.tradeName,
        dosage: this.Form.dosage + ' mg',
        sellUnitEn: this.Form.sellUnit
          ? `Sell per ${this.Form.unitEn} (${this.Form.sellUnit} tablets/pack)`
          : `Sell per ${this.Form.unitEn}`,
        sellUnitTh: this.Form.sellUnit
          ? `ขายต่อ${this.Form.unitTh} (${this.Form.sellUnit} /แผง)`
          : `ขายต่อ${this.Form.unitTh}`,
        unitEn: this.Form.unitEn,
        unitTh: this.Form.unitTh,
        dosageEn: this.Form.dosageEn,
        dosageTh: this.Form.dosageTh,
        howToTakeEn: this.Form.howToTakeEn,
        howToTakeTh: this.Form.howToTakeTh,
        timeEn: this.Form.timeEn,
        timeTh: this.Form.timeTh,
        price: parseFloat(this.Form.price),
        cost: parseFloat(this.Form.cost),
        detailEn: this.Form.detailEn,
        detailTh: this.Form.detailTh,
        active: this.Form.active,
      };
      return payload;
    },
    async addNewMedicine() {
      const payload = this.preparePayload();
      await axios
        .post(`${process.env.VUE_APP_EPRES_ENDPOINT}admin/medicines/create`, payload)
        .then(() => {
          this.dialog = false;
          this.resetForm();
          this.$emit('success');
          this.$notify({
            title: 'Success',
            text: 'New medicine has been added successfully.',
            type: 'success',
          });
        })
        .catch((error) => {
          console.error('Error creating new medicine:', error);
          this.$notify({
            title: 'Error',
            text: 'There was an error adding the new medicine. Please try again.',
            type: 'error',
          });
        });
    },
    async updateMedicine() {
      const payload = this.preparePayload();
      console.log('Update medicine payload:', payload);
      await axios
        .patch(`${process.env.VUE_APP_EPRES_ENDPOINT}admin/medicines/${this.medicineId}/update`, payload)
        .then(() => {
          this.dialog = false;
          this.resetForm();
          this.$emit('success');
          this.$notify({
            title: 'Success',
            text: 'Medicine has been updated successfully.',
            type: 'success',
          });
        })
        .catch((error) => {
          console.error('Error updating medicine:', error);
          this.$notify({
            title: 'Error',
            text: 'There was an error updating the medicine. Please try again.',
            type: 'error',
          });
        });
    },
    async deleteMedicine() {
      this.$root
        .$confirm(
          'Delete Medicine',
          `Are you sure you want to delete medicine for <b>${this.medicine.genericName}</b>? This action cannot be undone.`,
          { color: 'red' }
        )
        .then(async (confirm) => {
          if (confirm) {
            console.log('Delete medicine with id:', this.medicineId);
            await axios
              .patch(`${process.env.VUE_APP_EPRES_ENDPOINT}admin/medicines/${this.medicineId}/delete`)
              .then(() => {
                this.dialog = false;
                this.resetForm();
                this.$emit('success');
                this.$notify({
                  title: 'Success',
                  text: 'Medicine has been deleted successfully.',
                  type: 'success',
                });
              })
              .catch((error) => {
                console.error('Error deleting medicine:', error);
                this.$notify({
                  title: 'Error',
                  text: 'There was an error deleting the medicine. Please try again.',
                  type: 'error',
                });
              });
          }
        });
    },
    onlyNumberAndDecimal(e) {
      const char = String.fromCharCode(e.keyCode);
      if (!/[0-9.]/.test(char)) {
        e.preventDefault();
      }
      if (char === '.' && e.target.value.includes('.')) {
        e.preventDefault();
      }
    },
    fillFormFromMedicine() {
      console.log(this.medicine);
      this.$nextTick(() => {
        this.$refs.medicineForm.resetValidation();
      });
      this.medicineId = this.medicine._id;
      this.Form.genericName = this.medicine.genericName;
      this.Form.tradeName = this.medicine.tradeName;
      this.Form.dosage = this.medicine.dosage.replace(' mg', '');
      this.Form.sellUnit = this.medicine.sellUnitEn;
      const match = this.medicine.sellUnitEn.match(/\d+/);
      this.Form.sellUnit = this.Form.sellUnit = match ? parseInt(match[0], 10) : null;
      this.unitSelect = {
        en: this.medicine.unitEn,
        th: this.medicine.unitTh,
      };
      this.Form.dosageEn = this.medicine.dosageEn;
      this.Form.dosageTh = this.medicine.dosageTh;
      this.Form.howToTakeEn = this.medicine.howToTakeEn;
      this.Form.howToTakeTh = this.medicine.howToTakeTh;
      this.Form.price = this.medicine.price.toString();
      this.Form.cost = this.medicine.cost.toString();
      this.Form.timeEn = this.medicine.timeEn;
      this.Form.timeTh = this.medicine.timeTh;
      this.Form.detailEn = this.medicine.detailEn;
      this.Form.detailTh = this.medicine.detailTh;
      this.Form.active = this.medicine.active;
    },
    resetForm() {
      this.$nextTick(() => {
        this.$refs.medicineForm.reset();
        this.$refs.medicineForm.resetValidation();
      });
      this.Form.reset();
      this.unitSelect = {
        en: 'Pill',
        th: 'เม็ด',
      };
    },
  },
  watch: {
    dialog(val) {
      if (val && !this.isAdd && this.medicine) {
        this.fillFormFromMedicine();
      }
    },
  },
};
</script>
